// reducers/index.js
import { combineReducers } from '@reduxjs/toolkit';
import counterReducer from './brandingSlice';

const rootReducer = combineReducers({
  branding: counterReducer,
  // Add more reducers here if needed
});

export default rootReducer;
